/**
 * 将日期字符串格式化为 MM月DD日
 * @param {string} dateStr - 日期字符串，如 '2020-07-23 12:33'
 * @returns {string} 格式化后的字符串，如 '07月23日'
 */
export function formatMD(dateStr) {
  const d = new Date(dateStr);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${m}月${day}日`;
}

export const autoFillImagePath = (path) => {
  const prefix = "https://image.jiqizhixin.com";
  const isLocal = location.origin.includes("lvh.me") || location.origin.includes("localhost");
  return isLocal ? path ? `${prefix}${path}`: path : path;
};